import {
  requestItalenRequest
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求
import ajax from "../../../api/ajax";


const state = {}

const getters = {}

const actions = {
  async getItalenAttenRequest ({commit}, params) {
    ajax.defaults.timeout = 3600000; //这个接口响应时间较大改成1小时
    return requestItalenRequest(getUrl(params)).then(response => response)
  },

};

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/italen/italen.js